import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Heading from '@alltrails/denali/components/Heading';
import PlusContainerBadge from '@alltrails/denali/components/SubscriptionBadge/Container/Plus';
import Directions from '@alltrails/denali/icons/Directions';
import MapsThreeD from '@alltrails/denali/icons/MapsThreeD';
import Weather28 from '@alltrails/denali/icons/Weather28';
import styles from './PlusInfoModule.module.scss';

const rows: { icon: ReactNode; label: ReactNode }[] = [
  { icon: <Weather28 color="--color-text-plus" size="sm" />, label: <FormattedMessage defaultMessage="Real-Time Trail Conditions" /> },
  { icon: <Directions color="--color-text-plus" size="sm" />, label: <FormattedMessage defaultMessage="Wrong-Turn Alerts" /> },
  { icon: <MapsThreeD color="--color-text-plus" size="sm" />, label: <FormattedMessage defaultMessage="Trail Previews in 3D" /> }
];

// Peak-only "And includes all Plus benefits" module.
export default function PlusInfoModule() {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <PlusContainerBadge size="sm" />
        <Heading as="h3" size="300">
          <FormattedMessage defaultMessage="And includes all Plus benefits" />
        </Heading>
      </div>
      <ul className={styles.list}>
        {rows.map((row, index) => (
          <li key={index} className={styles.row}>
            <span aria-hidden className={styles.iconCircle}>
              {row.icon}
            </span>
            <Typography variant="text200bold">{row.label}</Typography>
          </li>
        ))}
      </ul>
    </div>
  );
}
